export default (theme) => ({
  actionButtons: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'space-between',
    '& > span': {
      position: 'relative',
      display: 'flex',
    },
    '& .to-right': {
      marginLeft: 'auto',
    },
    '& .in-progress': {
      marginRight: 8,
    },
  },
  form: {
    margin: 24,
    marginTop: '10vh',
    // [theme.breakpoints.up('md')]: {},
  },
  header: {
    lineHeight: '32px',
    display: 'flex',
    '& > a': {
      marginTop: 4,
      marginBottom: 4,
      marginRight: 8,
      width: 24,
      height: 24,
      color: 'inherit',
    },
    '& > h2': {
      fontSize: 24,
      display: 'inline-block',
      fontWeight: 400,
      marginTop: 0,
      // marginBottom: 0,
    }
  },
  text: {
    margin: 0,
    marginBottom: 16,
    textAlign: 'left',
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: 1.5,
    '& > p:first-child': {
      marginTop: 0,
    },
  },
})



// WEBPACK FOOTER //
// ./src/components/common/Styles/index.js